// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class UnregisteredLocationRecord extends VerofreshRecord {
  static get endpoint () { return 'location/unregistered' }
}
export default UnregisteredLocationRecord
